var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-progress"},[_c('span',{staticClass:"v-progress__bar",style:({ width: _vm.progress + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }